"use strict";
const turnstileSelector = '.js-turnstile';
const insertTokenToInput = (responseInputClass, token) => {
    const inputs = document.querySelectorAll('.' + responseInputClass);
    inputs.forEach(input => (input.value = token));
};
window.up.compiler(turnstileSelector, (element) => {
    const params = element.dataset;
    const responseInputClass = element.dataset.responseInputClass;
    if (window.turnstile && responseInputClass) {
        window.turnstile.render(element, Object.assign(Object.assign({}, params), { callback: (token) => insertTokenToInput(responseInputClass, token) }));
    }
});
